import {
  Box,
  Button,
  InputAdornment,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/editors.module.scss";
import assest from "../../json/assest";
// import Image from 'next/image'
import { Link } from "react-router-dom";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDate1,
  getUtcDateTime,
  getUtcTime,
  roleFinder,
} from "../../lib/functions/utils.lib";
import ManagerDeniedRejectedApprovedfilterModal from "./ManagerDeniedRejectedApprovedfilterModal";
import ManagerConfirmedApprovedApprovedFilter from "./ManagerConfirmedpprovedApprovedFilter";
import { useEffect } from "react";
import { useState } from "react";
import { getManagerVideos } from "../../api/functions/manager.api";
import { useQuery } from "react-query";
import {
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  // setManagerId,
  setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
} from "../../redux-toolkit/slices/managerConfirmedApprovedApproved.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import Filter from "../Filter/Filter";
import EmptyTable from "../EmptyTable/EmptyTable";
import ApiLoader from "../Loaders/ApiLoader";
import Pagination from "../UtilitiesComponent/Pagination";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import NoResult from "../NoResult/NoResult";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";
import ManagerConfirmNoResult from "../NoResult/ManagerConfirmNoResult";

const rows = [
  {
    vsid: "13194",
    acquisitor: "Theodore",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail1}`,
    title:
      "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "true",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Maxime Barronier",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail2}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "highlight",
    unreadDot: "true",
    unreachMail: "true",
  },
  {
    vsid: "13194",
    acquisitor: "Muhammad Ali Waqas",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail3}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "August 6, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "August 6, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "highlight",
    unreadDot: "true",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Theodore Doulkeris",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail4}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Maxime Barronier",
    acquisitorDesignation: "Content Buyer",
    thumbnail: `${assest.tabthumbnail5}`,
    title: "Girl Tries Hitting a Car with Her Hand at a Traffic Light",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "June 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "June 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "highlight",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Theodore",
    acquisitorDesignation: "Partner",
    thumbnail: `${assest.tabthumbnail6}`,
    title:
      "Girl Gets Surprised with a Baby Yoda Toy That She Wanted for So Long",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "January 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "January 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "true",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Maxime Barronier",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail7}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "October 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "October 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Maxime Barronier",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail8}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Awais",
    acquisitorDesignation: "Member",
    thumbnail: `${assest.tabthumbnail9}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "April 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "April 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Awais",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail5}`,
    title:
      "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "March 30, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "March 30, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Awais",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail6}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "November 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "November 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Awais",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail7}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "Ahmed Mamdouh",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Awais",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail8}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Awais",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail9}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Shafeeq Waqas",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail5}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Shafeeq Waqas",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail6}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Shafeeq Waqas",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail7}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Avraam Pedritis",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail5}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Avraam Pedritis",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail7}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
  {
    vsid: "13194",
    acquisitor: "Avraam Pedritis",
    acquisitorDesignation: "",
    thumbnail: `${assest.tabthumbnail5}`,
    title: "Rabbit on fence",
    submitterName: "John Smith",
    emailAddress: "johnsmith@gmail.com",
    submissionDate: "September 26, 2019",
    submissionTime: "at 05:45:23 AM UTC",
    approveBy: "John Martin",
    designation: "QC Agent",
    approveDate: "Aug 7, 2019 at 04:24:55 PM UTC",
    publishingDate: "September 26, 2019",
    publishingTime: "at 05:45:23 AM UTC",
    type: "",
    unreadDot: "",
    unreachMail: "",
  },
];

const ManagerDeniedRejectedApprovedTable = (props) => {
  const dispatch = useAppDispatch();
  const {
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    // manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
  } = useAppSelector((s) => s.managerConfirmedApprovedApprovedSlice);

  const [searchValue, setSearchValue] = React.useState("");
  const {
    filterRowProps,
    datas,
    handlePageChange,

    p,
    // handleClearFilterModal,
    hideFilter,
  } = props;
  const [page, setPage] = useState(1);

  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearchValue(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };

  //   console.warn(from, to, hasMessage, has_note, "filter")

  const {
    data,
    isLoading,
    refetch: refetchAgain,
  } = useQuery(
    ["RejectedToApproved", props?.selectedId, searchValue],

    async () => {
      return getManagerVideos({
        manager_id: props?.selectedId,
        search: searchValue,
        page: page,
        manager_decision: "2",
        quality_team_decision: "1",
        has_note,
        unreachable_submitter,
        submit_place: submit_other_website,
        country: submit_place,
        hasMessage,
        month,
        year,
        user_id,
        quality_team_id,
        people_appearing,
        person_who_filmed,
        aggrement_with_another_company,
        from,
        to,
      });
    }
  );

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const handleDataFromChild = (e) => {
    setPage(e);
    handleTriggreFetch();
    // Do something with the data received from the child component
  };

  const [openFilterModal, setOpenFilterModal] = useState(false);

  const filterRefetch = () => {
    refetchAgain();
    setOpenFilterModal(false);
  };

  const filtersReset = () => {
    dispatch(setHasNote(null));
    // dispatch(setFrom(null));
    // dispatch(setTo(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setQualityTeamId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setHasMessage(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    handleTriggreFetch();
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    dispatch(setQualityTeamId(null));

    dispatch(setHasMessage(null));

    handleTriggreFetch();
    setOpenFilterModal(false);
    // refetchAgain();
  };
  useEffect(() => {
    refetchAgain();
  }, [fetchTrigger]);

  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    if (
      has_note ||
      unreachable_submitter ||
      hasMessage ||
      month ||
      year ||
      submit_place ||
      user_id ||
      quality_team_id ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    has_note ||
      unreachable_submitter ||
      hasMessage ||
      month ||
      year ||
      submit_place ||
      user_id ||
      quality_team_id ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company,
  ]);

  // modal design

  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  // modal design
  return (
    <>
      <ManagerConfirmedApprovedApprovedFilter
        allvideosCount={data?.data?.total}
        fliterText={"approved"}
        {...filterRowProps}
        FilterModalComponent={ManagerDeniedRejectedApprovedfilterModal}
        filterModalProps={{
          setOpenFilterModal,
          openFilterModal,
          searchValue,
          handleTriggreFetch,
          setSearchValue,
          hideBottom: false,
          filterRefetch,
          filtersReset,
          handleClearFilterModal,
          p,
          states: {
            has_note,
            unreachable_submitter,
            hasMessage,
            month,
            year,
            submit_place,
            user_id,
            // manager_id,
            quality_team_id,
            people_appearing,
            person_who_filmed,
            submit_other_website,
            aggrement_with_another_company,
            from,
            to,
          },
          setStates: {
            setHasNote,
            setUnreachableSubmitter,
            setHasMessage,
            setMonth,
            setYear,
            setSubmitPlace,
            setUserId,
            // setManagerId,
            setQualityTeamId,
            setPeopleAppearing,
            setPersonWhoFilmed,
            setSubmitOtherWebsite,
            setAgreementWithAnotherCompany,
            setFrom,
            setTo,
          },
        }}
      />
      <Box className={`${styles.stickytable} ${styles.forManagerInquire}`}>
        <Box className={`${styles.tableResponsive} ${styles.scrollRoot}`}>
          <TableContainer className={styles.managerConAppScroll}>
            <Table className={styles.managerConfirmTable} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={styles.thconfirmVsid}>VSID</TableCell>
                  <TableCell className={styles.thconfirmAcquisitor}>
                    Acquisitor
                  </TableCell>
                  <TableCell className={styles.thconfirmThumbnail}>
                    Thumbnail
                  </TableCell>
                  <TableCell className={styles.thconfirmTitle}>Title</TableCell>
                  <TableCell className={styles.thconfirmSubmitter}>
                    Submitter Name
                  </TableCell>
                  <TableCell className={styles.thconfirmEmail}>
                    Email Address
                  </TableCell>
                  <TableCell className={styles.thconfirmSubmission}>
                    Submission Date
                  </TableCell>
                  <TableCell className={styles.thconfirmApproved}>
                    Rejected on
                  </TableCell>
                  <TableCell className={styles.thconfirmInquiring}>
                    Approved by
                  </TableCell>
                  <TableCell align="center" className={styles.thconfirmView}>
                    View
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <ApiLoader loading={isLoading} />
                ) : data?.data?.data.length > 0 ? (
                  data?.data?.data?.map((row) => (
                    <>
                      <TableRow
                        className={`${
                          row.type === "highlight"
                            ? `${styles.trHighlight}`
                            : null
                        }`}
                      >
                        <TableCell scope="row" className={styles.thconfirmVsid}>
                          <Typography variant="body2">
                            {row?.id}
                            {row.unseen_messages ? (
                              <span className={styles.redDot}></span>
                            ) : (
                              <></>
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmAcquisitor}>
                          <Typography
                            variant="body2"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {row?.user?.name}{" "}
                            {row?.user?.last_name !== null
                              ? row?.user?.last_name
                              : ""}
                          </Typography>
                          <Typography
                            variant="overline"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {/* {row?.acquisitorDesignation} */}
                            {roleFinder(row.user?.role_id)}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmThumbnail}>
                          <img
                            onClick={() => onOpenTwo(row.id)}
                            src={concatHostAndImagePath(row?.thumbnail)}
                            width={73}
                            height={46}
                            alt="image"
                            className={styles.thumImg}
                          />
                        </TableCell>
                        <TableCell className={styles.thconfirmTitle}>
                          <Typography
                            variant="body1"
                            className={styles.tableTitle}
                          >
                            {row?.title}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmSubmitter}>
                          <Typography
                            variant="body2"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {row?.first_name + " " + row?.last_name}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmEmail}>
                          <Typography
                            variant="body2"
                            className={styles.emailTxt}
                          >
                            {row?.email}
                            <br />
                            {row?.unreachable_submitter ? (
                              <span className={styles.mailerror}>
                                Unreachable Email
                              </span>
                            ) : null}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmSubmission}>
                          <Typography variant="body2">
                            {/* <br /> {row?.submissionTime} */}
                            {getUtcDate(row.created_at)} <br />{" "}
                            {getUtcTime(row.created_at)}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmApproved}>
                          <Typography variant="body2">
                            {/* <br /> {row?.publishingTime} */}
                            {getUtcDate(
                              row?.video_meta?.manager_updated_at
                            )}{" "}
                            <br />{" "}
                            {getUtcTime(row?.video_meta?.manager_updated_at)}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thconfirmInquiring}>
                          <Typography
                            variant="body2"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {row?.quality_team?.name}{" "}
                            {row?.quality_team?.last_name}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {/* {row?.designation} */}
                            {"qc-agent"}
                          </Typography>
                          <Typography
                            variant="body2"
                            className={styles.aprDate}
                          >
                            {/* {row?.video_meta?.quality_team_updated_at !== null
                              ? getUtcDateTime(
                                row?.video_meta?.quality_team_updated_at
                              )
                              : ""} */}
                            {getUtcDate1(row?.video_meta.manager_updated_at)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.thconfirmView}
                        >
                          {/*  <Link target="_blank" to={`video/${row?.id}`} className={styles.StyledeyeIcon}>
                                                        <img src={assest.IconView} width={16} height={16} alt='icon' />
                                                    </Link> */}
                          <Button onClick={() => onOpen(row.id)}>
                            <img
                              src={assest.IconView}
                              width={16}
                              height={16}
                              alt=""
                            />
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow className={styles.blnkTd}>
                        <TableCell colSpan={10}>{""}</TableCell>
                      </TableRow>
                    </>
                  ))
                ) : (
                  <TableRow className={styles.nonHover}>
                    <TableCell colSpan={10}>
                      {/* {has_note ||
                        unreachable_submitter ||
                        hasMessage ||
                        month ||
                        year ||
                        submit_place ||
                        user_id ||
                        // manager_id ||
                        quality_team_id ||
                        people_appearing ||
                        person_who_filmed ||
                        submit_other_website ||
                        aggrement_with_another_company ||
                        !from ||
                        !to ? (
                          <>
                            <Filter resetFilters={filtersReset} />
                          </>
                        ) : (
                          <>
                            <EmptyTable
                              emptyTableText={
                                "You have no approved videos at the moment. Please reload the page or check back later."
                              }
                            />
                          </>
                        )} */}
                      {filterActive ? (
                        <>
                          <Filter resetFilters={filtersReset} />
                        </>
                      ) : (
                        <>
                          {searchValue || from || to ? (
                            <ManagerConfirmNoResult
                              heading={"approved"}
                              query={searchValue}
                            />
                          ) : (
                            <EmptyTable
                              emptyTableText={
                                "You have no approved videos at the moment. Please reload the page or check back later."
                              }
                            />
                          )}
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                )}

                {data?.data?.total > 0 ? (
                  <TableRow className={styles.nonHover}>
                    <TableCell colSpan={10}>
                      <Box className={styles.innerPagination}>
                        {data?.data?.total < 12 ? (
                          <div
                            style={{
                              color: "#828282",
                              textAlign: "center",
                              fontSize: "13px",
                              padding: "5px 0px",
                            }}
                          >
                            <p>
                              {searchValue?.length > 0
                                ? "End of list. We couldn't find more videos matching your search."
                                : filterActive
                                ? "End of list. We couldn't find more videos matching your selected filter(s)."
                                : ""}
                            </p>
                          </div>
                        ) : (
                          <Pagination
                            lastpage={data?.data?.last_page}
                            onClick={undefined}
                            /* sendDataToParent={(page) => {
                              setPage(page);
                            }} */
                            sendDataToParent={handleDataFromChild}
                          />
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : null}

                {/* ============================================== */}
                {/* ========= END OF LIST MESSAGE START ========== */}

                {/* <TableRow className={styles.endOfList}>
                            <TableCell colSpan={9}>
                                <Typography variant='body1'>End of list. We couldn't find more videos the manager is inquiring about within the specified date range.</Typography>
                            </TableCell>
                        </TableRow> */}

                {/* ============================================== */}
                {/* ========== END OF LIST MESSAGE END =========== */}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* {data?.data?.total > 12 ? (
            <Box className={styles.innerPagination}>
              <Pagination
                lastpage={data?.data?.last_page}
                onClick={undefined}
                sendDataToParent={(page) => {
                  setPage(page);
                }}
              />
            </Box>
          ) : null} */}
        <VideoPageFullModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        <WatchVideoModal
          onClose={onCloseTwo}
          open={openModalTwo}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
      </Box>

      {/* ============================================= */}
      {/* ======== DATE RANGE NO RESULT START ========= */}

      {/* <Box className={styles.dateRangeNoresult}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.iconOops} width={36} height={41} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn't find any videos the manager is inquiring about within the specified date range.</Typography>
                </Box>
            </Box>

            <Box className={styles.dateRangeNoresult}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.smileIcon} width={36} height={42} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn't find any rejected videos within the specified date range.</Typography>
                </Box>
            </Box> */}

      {/* ============================================= */}
      {/* ========= DATE RANGE NO RESULT END ========== */}

      {/* ============================================= */}
      {/* ============= PAGE EMPTY START ============== */}

      {/* <Box className={`${styles.dateRangeNoresult} ${styles.emptyItem}`}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.roundRing} width={207} height={210} alt='icon' />
                    </figure>
                    <Typography variant='body1' sx={{ lineHeight: '25px !important' }}>All is clear! No inquiring videos found. <br />Please refresh the page or check again later.</Typography>
                </Box>
            </Box> */}

      {/* ============================================= */}
      {/* ============== PAGE EMPTY END =============== */}

      {/* ========================================== */}
      {/* ======= FOR FILTER NO RESULT START ======= */}

      {/* <Box className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.Magnifying} width={45} height={45} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn't find any matches for the selected filter(s).</Typography>
                    <Button>Reset filters</Button>
                </Box>
            </Box> */}

      {/* ========================================== */}
      {/* ======= FOR FILTER NO RESULT START ======= */}

      {/* ========================================== */}
      {/* ======= FOR SEARCH NO RESULT START ======= */}

      {/* <Box className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.Magnifying} width={45} height={45} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn’t find any matching videos the manager is inquiring abour for <span>john smith</span>.</Typography>
                </Box>
            </Box> */}

      {/* ========================================== */}
      {/* ======= FOR SEARCH NO RESULT START ======= */}
    </>
  );
};

export default ManagerDeniedRejectedApprovedTable;
